import "./index.css";

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-modal text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const DeleteFileModal = ({ isModalOpen, yesDelete, justCloseIt, fileInfo }) => {
  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content position-relative" >

          <p
            style={{
              position: "absolute",
              right: 12,
              width: "12px",
              top: "10px",
              height: "12px",
              cursor: "pointer",
            }}
            onClick={justCloseIt}
          >
            X
          </p>


          <div style={{ marginBottom: "20px" }}>
            <span className="modalTextBold" >Delete file</span>
          </div>

          <p className="modalText" >
            Are you sure you want to delete "{fileInfo?.name}" <br />
            This action cannot be undone.
          </p>

          <div className="flex items-center gap-4">
            <button type="submit" className="rounded-[3px] border-0 w-full py-3 bg-red-500 text-white font-medium" onClick={yesDelete}>
              Yes, delete file
            </button>

            <button className="rounded-[3px] w-full py-3 bg-black font-medium text-white" onClick={justCloseIt}>
              No, go back
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteFileModal;
